import { FCX } from "@datassential/platform-ui-lib";
import { ComponentProps } from "react";
import cn from "classnames";

export enum SkeletonShape {
    Rect = 'rect',
    Circle = 'circle',
    Text = 'text',
}

type SkeletonProps = Omit<ComponentProps<'div'>, 'children'> & {
    shape?: SkeletonShape;
    width?: number;
    height?: number;
    radius?: number;
}

const Skeleton: FCX<SkeletonProps> = ({
    shape = SkeletonShape.Text,
    width,
    height,
    radius = 4,
    className,
    testId,
    style,
    ...props
}) => {
    const getStyles = (): React.CSSProperties => {
        const baseStyles: React.CSSProperties = {
            width: width || '100%',
            height,
        };

        if (shape === SkeletonShape.Circle) {
            return {
                ...baseStyles,
                borderRadius: '50%',
                aspectRatio: '1/1',
            };
        }

        if (shape === SkeletonShape.Text) {
            return {
                ...baseStyles,
                height,
                borderRadius: radius,
            };
        }

        return {
            ...baseStyles,
            borderRadius: radius,
        };
    };

    return (
        <div
            className={cn("Skeleton", className)}
            data-testid={testId}
            style={{
                ...getStyles(),
                ...style,
            }}
            {...props}
        />
    );
};


export default Skeleton;
